import React from "react";
import {Tag} from "antd";
import AiPrompt from "../../domain/AiPrompt";
import {AI_PROMPT_CONFIG_KEY_LABELS} from "./AiPromptConfigKeys";

interface Props {
    aiPrompt?: AiPrompt;
}

function AiPromptConfigKeyTags(props: Props) {
    if (!props.aiPrompt?.configKeys?.length) {
        return null;
    }

    return (
        <>
            {props.aiPrompt.configKeys.map(configKey =>
                <Tag key={configKey} variant={"filled"} color="blue" title={configKey}>
                    {AI_PROMPT_CONFIG_KEY_LABELS[configKey] || configKey}
                </Tag>
            )}
        </>
    );
}

export default AiPromptConfigKeyTags;
